'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = _joi2.default.object().keys({
  api_key: _joi2.default.string().description('Your openrouteservice API key'),
  point: _joi2.default.object().keys({
    lat_lng: _joi2.default.array().length(2).items(_joi2.default.number().required()).required().description('The specific coordinate to reverse geocode, order latitude followed by longitude.'),
    radius: _joi2.default.number().description('The radius in kilometers to restrict the search around the focus point.')
  }).description('Point on earth and a maximum distance within which acceptable results can be located.'),
  sources: _joi2.default.array().items(_joi2.default.string().valid('osm', 'oa', 'wof', 'gn')).description("The originating source of the data. One or more of ['osm', 'oa', 'wof', 'gn']. Currently only 'osm', 'wof' and 'gn' are supported."),
  layers: _joi2.default.array().items(_joi2.default.string().valid('venue', 'address', 'street', 'neighbourhood', 'borough', 'localadmin', 'locality', 'county', 'macrocounty', 'region', 'macroregion', 'country', 'coarse')).description(' The administrative hierarchy level for the query. Refer to https://github.com/pelias/documentation/blob/master/search.md#filter-by-data-type for details.'),
  boundary_country: _joi2.default.array().items(_joi2.default.string()).description('Constrain query by country. Accepts alpha-2 or alpha-3 digit ISO-3166 country codes.'),
  size: _joi2.default.number().description('The amount of results returned. Default 10').default(10),
  host: _joi2.default.string().default('https://api.openrouteservice.org/geocode/reverse').description('Determines the API url.'),
  mime_type: _joi2.default.string().valid(['application/json']).default('application/json').description('Determines the mime type of request.')
}).unknown(false);

exports.default = schema;